module.exports = "\n<div class=\"panel simple\">\n  <div class=\"panel-title\">\n    <h3>Widgety</h3>\n  </div>\n  <div class=\"panel-body\">\n    <data-table [columns]=\"columns\" [rows]=\"rows\" [buttons]=\"actions\" [isLoading]=\"isLoading\"\n                [pager]=\"pager\" (tableChanged)=\"tableChanged($event)\"></data-table>\n  </div>\n</div>\n\n<widget-modal #widgetModal (refreshList)=\"refreshList($event)\"></widget-modal>"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/widgets/widgets.component.html
// module id = ../../../../../src/app/main/widgets/widgets.component.html
// module chunks = 1